import React from 'react';
import './DividerHeading.css';

const DividerHeading = ({ text }) => {
  return (
    <div className="divider-heading">
      <span className="text">{text}</span>
    </div>
  );
};

export default DividerHeading;
